import contentMiddleware from '@tshio/redux-api-content-middleware';
import createEndpointMiddleware from '@tshio/redux-api-endpoint-middleware';
import paramsMiddleware from '@tshio/redux-api-params-middleware';
import { applyMiddleware, Middleware } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { fixParamsMiddleware } from 'store/middlewares/fixParams.middleware';
import { getAppConfig } from 'utils/config/appConfig';
import {
  apiErrorsMiddleware,
  camelCaseMiddleware,
  numberApiCallsMiddleware,
  screenLockMarkerMiddleware,
  screenLockMiddleware,
  takeLatestMiddleware,
  fileDownloadMiddleware,
  normalizeAuthResponse,
  customFetchMiddleware,
} from './middlewares';
const endpointMiddleware = () =>
  createEndpointMiddleware({
    apis: {
      default: {
        apiUrl: getAppConfig('OSIN20_API_URL'),
        credentials: 'include',
      },
    },
  });

export const sagaMiddleware = createSagaMiddleware();

export const getMiddlewares = () => {
  return applyMiddleware(
    fixParamsMiddleware as Middleware,
    numberApiCallsMiddleware as unknown as Middleware,
    screenLockMarkerMiddleware as unknown as Middleware,
    camelCaseMiddleware as unknown as Middleware,
    endpointMiddleware(),
    paramsMiddleware,
    contentMiddleware,
    customFetchMiddleware as Middleware,
    apiMiddleware,
    normalizeAuthResponse as Middleware,
    takeLatestMiddleware as unknown as Middleware,
    fileDownloadMiddleware as unknown as Middleware,
    screenLockMiddleware as unknown as Middleware,
    apiErrorsMiddleware,
    thunk,
    sagaMiddleware,
  );
};
